export const errorFormat = (error: Error) => {
  const message = error.message.split(':');
  const lastMessage = message[message.length - 1];
  return (lastMessage || error.message || 'Erro desconhecido').trim();
};
